import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '@fry/upgrade/main.template.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard } from '@fry-it/risr-core';
import { forceOnlineGuard } from '@fry-it/risr-core';
import { unsavedGuard } from '@fry/upgrade/unsaved.guard';

// Import components as they are migrated
// These will be created later during component migration
import { MultiReportEditElementComponent, ReportRunComponent, ReportTemplateFormComponent, ReportTemplatesComponent, ReportWrapperComponent } from '@fry/upgrade/reports.directive';
// import { ReportRunComponent } from '@fry/upgrade/reports.directive';
// import { ReportTemplateFormComponent } from '@fry/upgrade/reports.directive';

export const reportsRoutes: Routes = [
  {
    path: 'report_templates',
    component: TwoColumnsRightComponent,
    data: {
      permission: 'reports.view'
    },
    canActivate: [setupGuard, authGuard, forceOnlineGuard],
    children: [
      {
        path: '',
        component: ReportTemplatesComponent,
        data: {
          angularJsTemplate: 'app/components/reports/templates_list.html',
          angularJsController: 'ReportTemplatesController',
          angularJsControllerAs: 'reportsCtrl',
          state: 'epf.reportTemplates.index'
        },
        canActivate: [forceOnlineGuard]
      },
      {
        path: 'run/:reportId',
        component: ReportRunComponent,
        data: {
          angularJsTemplate: 'app/components/reports/run.html',
          angularJsController: 'ReportRunController',
          angularJsControllerAs: 'reportsCtrl',
          state: 'epf.reportTemplates.run'
        },
        canActivate: [forceOnlineGuard]
      },
      {
        path: 'new',
        component: ReportTemplateFormComponent,
        data: {
          angularJsTemplate: 'app/components/reports/templates_form.html',
          angularJsController: 'ReportTemplateController',
          angularJsControllerAs: 'reportsCtrl',
          action: 'new',
          state: 'epf.reportTemplates.new',
          permission: 'reports.edit'
        },
        canActivate: [forceOnlineGuard, authGuard],
        canDeactivate: [unsavedGuard]
      },
      {
        path: ':reportId/edit',
        component: ReportTemplateFormComponent,
        data: {
          angularJsTemplate: 'app/components/reports/templates_form.html',
          angularJsController: 'ReportTemplateController',
          angularJsControllerAs: 'reportsCtrl',
          action: 'edit',
          state: 'epf.reportTemplates.edit',
          permission: 'reports.edit'
        },
        canActivate: [forceOnlineGuard, authGuard],
        canDeactivate: [unsavedGuard]
      },
      {
        path: 'edit/multi-report/:reportId/element/:elementId',
        component: MultiReportEditElementComponent,
        data: {
          angularJsTemplate: 'app/components/reports/multiReport.edit.element.html',
          angularJsController: 'MultiReportEditElementController',
          angularJsControllerAs: 'multiReportEditElementCtrl',
          action: 'edit',
          state: 'epf.reportTemplates.multi-report-edit-element',
          permission: 'reports.edit'
        },
        canActivate: [forceOnlineGuard, authGuard],
        canDeactivate: [unsavedGuard]
      },
      {
        path: 'edit/:reportId',
        redirectTo: '/report_templates/:reportId/edit'
      }
    ]
  },
  {
    path: 'reports/view/:location/:id/:blueprintId',
    component: ReportWrapperComponent,
    data: {
      angularJsTemplate: 'app/components/reports/view.html',
      angularJsController: 'ReportViewEventsController',
      angularJsControllerAs: 'reportViewEventsCtrl',
      state: 'epf.reportTemplates.view',
      permission: 'reports.view'
    },
    canActivate: [setupGuard, forceOnlineGuard, authGuard]
  },
  {
    path: 'reports/view/:location/:id/:blueprintId/:blueprintCatId',
    component: ReportWrapperComponent,
    data: {
      angularJsTemplate: 'app/components/reports/view.html',
      angularJsController: 'ReportViewEventsController',
      angularJsControllerAs: 'reportViewEventsCtrl',
      state: 'epf.reportTemplates.view',
      permission: 'reports.view'
    },
    canActivate: [setupGuard, forceOnlineGuard, authGuard]
  },
  {
    path: 'reports/view/:location/:id/:blueprintId/:blueprintCatId/:user',
    component: ReportWrapperComponent,
    data: {
      angularJsTemplate: 'app/components/reports/view.html',
      angularJsController: 'ReportViewEventsController',
      angularJsControllerAs: 'reportViewEventsCtrl',
      state: 'epf.reportTemplates.view',
      permission: 'reports.view'
    },
    canActivate: [setupGuard, forceOnlineGuard, authGuard]
  }
];
